import { render, staticRenderFns } from "./AchievementInfo.vue?vue&type=template&id=bcf8c982"
import script from "./AchievementInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AchievementInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports